import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { open: Boolean }

  connect() {
    this.boundClickOutside = this.clickOutside.bind(this)
    this.boundKeydown = this.keydown.bind(this)
  }

  disconnect() {
    this.close()
  }

  toggle() {
    this.openValue = !this.openValue
  }

  close() {
    this.openValue = false
  }

  openValueChanged() {
    this.menuTarget.classList.toggle("hidden", !this.openValue)
    if (this.openValue) {
      document.addEventListener("click", this.boundClickOutside)
      document.addEventListener("keydown", this.boundKeydown)
    } else {
      document.removeEventListener("click", this.boundClickOutside)
      document.removeEventListener("keydown", this.boundKeydown)
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) this.openValue = false
  }

  keydown(event) {
    if (event.key === "Escape") this.openValue = false
  }
}
